import {RemotePostChangeAddress} from 'data/usecases';
import {PostChangeAddress} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';

export const makePostChangeAddress = (): PostChangeAddress =>
	new RemotePostChangeAddress(
		makeBFFApiUrl(ProfileChangeDataEndpoints.changeAddress),
		makeAuthorizeHttpClientDecorator(),
	);
